import type { Tokens } from "../../modules/auth/tokens/tokenSchema";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

const initial_tokens: Tokens = {
  access_token: "",
  refresh_token: undefined,
};

const initialState = {
  isAuthenticated: false,
  tokens: initial_tokens,
  loading: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setTokens: (state, action: PayloadAction<Tokens | null>) => {
      state.isAuthenticated = !!action.payload;
      state.tokens = action.payload ?? initial_tokens;
    },
    setAuthLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setTokens, setAuthLoading } = authSlice.actions;
export default authSlice.reducer;
